import { getToken, getUser } from "../commons";
import { getAPICall, postAPICall } from "./axiosCommons";
import Moment from "moment";

// GET NGROK
export const searchAttendance = async (date_from, date_to, agent) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "timesheets/search",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(date_from).format("YYYY-MM-DD"),
        date_to: Moment(date_to).format("YYYY-MM-DD"),
        agent: agent,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const getUserDetail = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "users/get",
      {
        requester: getUser(),
        token: getToken(),
        user_id: id,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const addUser = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/add",
      {
        requester: getUser(),
        token: getToken(),
        role: data.role,
        first_name: data.first_name,
        last_name: data.last_name,
        username: data.username,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateUser = async (data) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "users/update",
      {
        requester: getUser(),
        token: getToken(),
        user_id: data.id,
        role: data.role,
        first_name: data.first_name,
        last_name: data.last_name,
        username: data.username,
      }
    );

    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "users/delete",
      {
        requester: getUser(),
        token: getToken(),
        user_id: id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
